import { render, staticRenderFns } from "./menu-manage.vue?vue&type=template&id=0a501275&scoped=true&"
import script from "./menu-manage.vue?vue&type=script&lang=js&"
export * from "./menu-manage.vue?vue&type=script&lang=js&"
import style0 from "./menu-manage.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./menu-manage.vue?vue&type=style&index=1&id=0a501275&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a501275",
  null
  
)

export default component.exports